import React from "react";
import VisitorLocation from "./VisitorLocation";

import { useLocation, useNavigate } from "react-router-dom";

import { CONTACT, practices } from "../data/content";
import { scrollToSection } from "../utils/scroll";

const SOCIAL = [
  {
    label: "X",
    href: "#",
    path: "M2 2h3.2l3.3 4.4L12.4 2H14l-4.7 5.4L14.3 14H11l-3.5-4.7L3.3 14H1.7l5-5.7z",
  },
  {
    label: "Facebook",
    href: "#",
    path: "M9.6 14V8.6h1.8l.3-2.1H9.6V5.2c0-.6.2-1 1-1h1.1V2.3c-.2 0-.9-.1-1.6-.1-1.7 0-2.8 1-2.8 2.8v1.5H5.4v2.1h1.9V14z",
  },
];

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const goToSection = (id) => {
    if (location.pathname === "/") {
      scrollToSection(id);
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <footer className="foot">
      <div className="wrap">
        <div className="footgrid">
          <div>
            <span className="brand-logo wht sm" role="img" aria-label="New Age Services" />
            <p className="tag">{CONTACT.tagline}</p>
            <div className="soc">
              {SOCIAL.map((s) => (
                <a key={s.label} href={s.href} aria-label={s.label}>
                  <svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true">
                    <path d={s.path} fill="#94A3CC" />
                  </svg>
                </a>
              ))}
              <a href={CONTACT.linkedin} aria-label="LinkedIn" target="_blank" rel="noreferrer">
                <svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true">
                  <path
                    d="M3.9 5.5H2.1V14h1.8zM3 2.2a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2M14 9.3c0-2.2-1.2-3.2-2.7-3.2-1.2 0-1.8.7-2.1 1.2V5.5H7.4V14h1.8V9.4c0-1 .5-1.7 1.4-1.7s1.5.6 1.5 1.7V14H14z"
                    fill="#94A3CC"
                  />
                </svg>
              </a>
            </div>
            <VisitorLocation />
          </div>

          <div>
            <h4>Useful Links</h4>
            <ul>
              <li>
                <button type="button" onClick={() => goToSection("home")}>Home</button>
              </li>
              <li>
                <button type="button" onClick={() => goToSection("about")}>About</button>
              </li>
              <li>
                <button type="button" onClick={() => goToSection("services")}>Services</button>
              </li>
              <li>
                <button type="button" onClick={() => goToSection("contact")}>Contact</button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => navigate("/TermsAndConditions/TermsAndConditions")}
                >
                  Terms &amp; Conditions
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/PrivacyPolicy/PrivacyPolicy")}>
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4>Our Services</h4>
            <ul>
              {practices.map((p) => (
                <li key={p.id}>
                  <button type="button" onClick={() => navigate(`/Services/Services#${p.id}`)}>
                    {p.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4>Our Locations</h4>
            <ul>
              {CONTACT.offices.map((o) => (
                <li key={o}>{o.toUpperCase()}</li>
              ))}
            </ul>
            <h4 style={{ marginTop: 22 }}>Connect With Us</h4>
            <ul>
              <li>
                <strong style={{ color: "var(--fg)" }}>For Sales &amp; Business Inquiries:</strong>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="base">
          <span className="mono">
            © {new Date().getFullYear()} New Age Services, All Rights Reserved
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
